var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"breadcrumb",attrs:{"tag":"a","to":_vm.to}},[_c('span',{staticClass:"breadcrumb__arrow"},[_vm._v("˂")]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }